import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    dataSeries;
    dataX;
    timeIntervalType;
    color;
    currQueueing;
    mounted() { }
    get currQueueingLen() {
        console.log('curr queueing:', Object.keys(this.currQueueing || {}).length);
        return Object.keys(this.currQueueing || {}).length > 0;
    }
    get currQueueNum() {
        return this.currQueueing?.queueingCount || 0;
    }
    get directionOneHour() {
        return (this.currQueueing && this.currQueueing.forecastChainRateInSpeedOneHour >= 0) || true;
    }
    get directionFourHour() {
        return this.currQueueing && this.currQueueing.forecastChainRateInSpeedFourHour >= 0;
    }
    get directionOneDay() {
        return this.currQueueing && this.currQueueing.forecastChainRateInSpeedOneDay >= 0;
    }
    get abaundant() {
        const res = this.currQueueing && this.currQueueing.abandonPercent ? (this.currQueueing.abandonPercent * 1 * 100).toFixed(2) : 0;
        console.log('res:', res);
        return res;
    }
    get currOneDay() {
        const res = this.currQueueing && this.currQueueing.forecastChainRateInSpeedOneDay
            ? (this.currQueueing.forecastChainRateInSpeedOneDay * 1 * 100).toFixed(2)
            : 0;
        return res;
    }
    get currOneHour() {
        const res = this.currQueueing && this.currQueueing.forecastChainRateInSpeedOneHour
            ? (this.currQueueing.forecastChainRateInSpeedOneHour * 1 * 100).toFixed(2)
            : 0;
        return res;
    }
};
__decorate([
    Prop()
], default_1.prototype, "dataSeries", void 0);
__decorate([
    Prop()
], default_1.prototype, "dataX", void 0);
__decorate([
    Prop()
], default_1.prototype, "timeIntervalType", void 0);
__decorate([
    Prop()
], default_1.prototype, "color", void 0);
__decorate([
    Prop()
], default_1.prototype, "currQueueing", void 0);
default_1 = __decorate([
    Component({
        name: 'Dashboard',
        i18n: {
            messages: {
                'en-us': {
                    currentPeople: 'Current Queuing Number',
                    remainTime: 'Estimated Remaining Time',
                    abandonTime: 'Abandonment Rate in the past hour',
                    entrySpeed: 'Park Entry Speed',
                    departureSpeed: 'Park Departure Speed',
                    hourTrend: 'Trend in the next hour',
                    hourTrend12: 'Trend in the next 4 hour',
                    hourTrend24: 'Trend in the next 24 hour',
                    peoplePerHour: 'people per hour',
                    perHour: 'per hour',
                    min: 'min',
                    currSpeed: 'Queue Speed',
                    peopleMin: 'ppl/min',
                },
                zh: {
                    currentPeople: '当前排队人数',
                    remainTime: '预计排队时长',
                    abandonTime: '过去1h弃排率',
                    entrySpeed: '进入景点速度',
                    departureSpeed: '出园速度',
                    hourTrend: '未来一小时环比',
                    hourTrend12: '未来4小时环比',
                    hourTrend24: '未来24小时环比',
                    peoplePerHour: '人/小时',
                    perHour: '/小时',
                    min: '分',
                    currSpeed: '排队通行速度',
                    peopleMin: '人/分',
                },
            },
        },
    })
], default_1);
export default default_1;
